import { Route, Routes } from "react-router-dom";
import { useState, useEffect } from "react";
import { useMsal, MsalProvider } from "@azure/msal-react";
import { EventType, PublicClientApplication } from "@azure/msal-browser";
import { api, oidcApi } from "./Utils/API/index";
import loadingGif from "./Assets/Images/loading.gif";


import "bootstrap/dist/css/bootstrap.min.css";
import "./Assets/Styles/App.scss";


// Anonymous User Screen Import

import MainContactUsPage from "./Pages/Anonymous/ContactUs";
import LoginCustomer from "./Pages/Anonymous/Login";
import ForgetPasswordCustomer from "./Pages/Anonymous/ResetPassword";
import CustomerNavbar from "./Layouts/Navbars/CustomerNavbar/CustomerNavbar";

// Authenticated User Screen Import

import ChangePassword from "./Pages/Customer/ChangePassword";
import MyProfileCustomer from "./Pages/Customer/MyProfile";
import ManagementConsoleCustomer from "./Pages/Customer/ManagementConsole";
import MicrosoftCSPServiceManagement from "./Pages/Customer/ManagementConsole/MicrosoftCSPServiceManagement";
import GoogleWorkspaceServiceManagement from "./Pages/Customer/ManagementConsole/GoogleWorkspaceServiceManagement";
import Footer from "./Layouts/Footer";
import RaiseATicket from "./Pages/Customer/RaiseATicket";
import CmsDetailsState from "./Context/CmsDetails/CmsDetailsSate";
import PageNotFound from "./Components/EmptyStates/PageNotFound";
import TicketDetails from "./Pages/Customer/TicketDetails";
import OrderHistory from "./Pages/Customer/OrderHistory";
import ProtectedRoute from "./Components/ProtectedRoute";
 
const MainContent = ({ isSSOUser }) => {
  const { instance, accounts } = useMsal();
  // Original authentication logic
const [customerIsAuthenticated, setCustomerIsAuthenticated] = useState(false); // Customer is authenticated Flag

  // Combine MSAL auth state with original auth state
  const msalIsAuthenticated = accounts.length > 0;
  const finalIsAuthenticated = customerIsAuthenticated || msalIsAuthenticated;

  // SSO login-in-progress: true from the moment MSAL redirect is detected until ManagementConsole signals data is ready.
  // This keeps a continuous loading overlay from the Microsoft redirect-back until the Management Console data loads.
  const [ssoLoginInProgress, setSsoLoginInProgress] = useState(
    // Initialise to true if we're already in an SSO redirect-back scenario on mount
    // (msalIsAuthenticated would be true but customerIsAuthenticated not yet set)
    false
  );

  // UseStates Defination
  const [isCustomer, setIsCustomer] = useState(true);
  const [profileInitialCredentialChange, setProfileInitialCredentialChange] = useState(false); // Keeping Count of Profile Image initials change
  const [activeLocalKey, setActiveLocalKey] = useState("default"); // navigation bar default value
  const [pageNotFound, setPageNotFound] = useState(false); // Page not found Flag
  const [roleType, setRoleType] = useState(sessionStorage.getItem("sso_role_type") || "read-and-write"); // Role-based access: "read" | "read-and-write"

  useEffect(() => {
    let value = sessionStorage.getItem("customerIsAuthenticated");
    if (value) {
      setCustomerIsAuthenticated(value === 'true'); // Defining default value that customer is signed in or not
    }
  }, []);

  // Detect SSO redirect-back: MSAL has an account but internal session not yet established
  useEffect(() => {
    if (isSSOUser && msalIsAuthenticated && !customerIsAuthenticated) {
      setSsoLoginInProgress(true);
    }
  }, [isSSOUser, msalIsAuthenticated, customerIsAuthenticated]);

  const setAuthentication = (value) => {
    sessionStorage.setItem("customerIsAuthenticated", value);
    setCustomerIsAuthenticated(value); // Defining value that customer is signed in or not after change in useState
  };

  return (
    <>
    {/* SSO loading overlay: single fully solid white screen shown from Microsoft redirect-back
        until ManagementConsole data is fully loaded. Rendered on top of Routes so ManagementConsole
        can still mount and call setSsoLoginInProgress(false) when data is ready. */}
    {ssoLoginInProgress && (
      <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: '#ffffff', zIndex: 9999 }}>
        <img src={loadingGif} alt="Loading..." />
      </div>
    )}
    <CmsDetailsState>
      <div className="main-page">
   {(finalIsAuthenticated && customerIsAuthenticated) && isCustomer && !pageNotFound && (
   <>
   <CustomerNavbar
     setCustomerIsAuthenticated={setAuthentication}
     activeLocalKey={activeLocalKey}
     setActiveLocalKey={setActiveLocalKey}
          profileInitialCredentialChange={profileInitialCredentialChange}
                setProfileInitialCredentialChange={setProfileInitialCredentialChange}
 isSSOUser={isSSOUser}
           />
     {/* Navbar visible to logged in Customer */}
        </>
     )}
          <Routes>
      {/* Defining Routes for logged in Customer so that these pages
        cannot be explicitly accessed by unauthorized users */}
 <Route
path="/management-console/"
   element={
                <ProtectedRoute>
   <ManagementConsoleCustomer
             setCustomerIsAuthenticated={setAuthentication}
         activeLocalKey={activeLocalKey}
       setActiveLocalKey={setActiveLocalKey}
     customerIsAuthenticated={finalIsAuthenticated}
         isSSOUser={isSSOUser}
    ssoLoginInProgress={ssoLoginInProgress}
     setSsoLoginInProgress={setSsoLoginInProgress}
     roleType={roleType}
       />
    </ProtectedRoute>
          }
   />
    <Route path="/profile/" element={<ProtectedRoute><MyProfileCustomer customerIsAuthenticated={finalIsAuthenticated} setCustomerIsAuthenticated={setAuthentication} profileInitialCredentialChange={profileInitialCredentialChange} setProfileInitialCredentialChange={setProfileInitialCredentialChange} isSSO={isSSOUser} instance={instance} roleType={roleType} /></ProtectedRoute>} />
            <Route path="/change-password/" element={<ProtectedRoute><ChangePassword /></ProtectedRoute>} />
            <Route
            path="/management-console/microsoft-csp/"
              element={<ProtectedRoute><MicrosoftCSPServiceManagement /></ProtectedRoute>}
       />
            <Route
    path="/management-console/google-workspace/"
   element={<ProtectedRoute><GoogleWorkspaceServiceManagement /></ProtectedRoute>}
            />
      <Route path="/create-support-ticket" element={<ProtectedRoute><RaiseATicket customerIsAuthenticated={finalIsAuthenticated} setCustomerIsAuthenticated={setAuthentication} isSSO={isSSOUser} instance={instance} roleType={roleType} /></ProtectedRoute>} />
       <Route path="/support-tickets" element={<ProtectedRoute><TicketDetails setActiveLocalKey={setActiveLocalKey} customerIsAuthenticated={finalIsAuthenticated} setCustomerIsAuthenticated={setAuthentication} isSSO={isSSOUser} instance={instance} /></ProtectedRoute>}  />
            <Route path="/order-history" element={<ProtectedRoute><OrderHistory setActiveLocalKey={setActiveLocalKey} customerIsAuthenticated={finalIsAuthenticated} setCustomerIsAuthenticated={setAuthentication} isSSO={isSSOUser} instance={instance}  /></ProtectedRoute>}/>

         {/* Defining Routes for unauthorized Customers */}
     <Route
path="/"
   element={
           <LoginCustomer
      customerIsAuthenticated={finalIsAuthenticated}
      setCustomerIsAuthenticated={setAuthentication}
         isSSOUser={isSSOUser}
         setRoleType={setRoleType}
                />
    }
        />
    <Route
    path="/reset-password/"
    element={<ForgetPasswordCustomer />}
          />
      <Route path="*" element={<PageNotFound setPageNotFound={setPageNotFound} />} />
     </Routes>
          {!pageNotFound && <Footer />} {/* Footer for all screen */}
 </div>
      </CmsDetailsState>
    </>
  );
};


function App() {
  const [msalInstance, setMsalInstance] = useState(null);
  const [isSSOUser, setIsSSOUser] = useState(null);

  useEffect(() => {
    const performSSOCheck = async () => {
      let dynamicOidcSettings = null;
      let ssoUser = false;
      try {
 // 1. Generate the key pair. The private key is non-extractable and stays within this scope.
        // console.log("Generating RSA key pair...");
   const keyPair = await window.crypto.subtle.generateKey(
          {
   name: "RSA-OAEP",
   modulusLength: 2048,
            publicExponent: new Uint8Array([1, 0, 1]),
   hash: "SHA-256",
     },
      false, // Non-extractable
        ["encrypt", "decrypt"]
 );
        // console.log("Key pair generated successfully.");

        // Export public key to send to the backend
        const publicKeyBuffer = await window.crypto.subtle.exportKey("spki", keyPair.publicKey);
    const publicKeyBase64 = btoa(String.fromCharCode(...new Uint8Array(publicKeyBuffer)));
    // console.log("Public Key (Base64):", publicKeyBase64);

 // 2. Make the API call
        // console.log("Fetching OIDC settings with public key...");
        const response = await api.get(`/b2b2c-user/oidc/settings?publicKey=${encodeURIComponent(publicKeyBase64)}`);

        if (response.status !== 204 && response.data) {
   // console.log("Received OIDC settings payload. Decrypting...");
 const encryptedKeyBuffer = Uint8Array.from(atob(response.data.encryptedKey), c => c.charCodeAt(0));
          const aesKeyBuffer = await window.crypto.subtle.decrypt(
            { name: "RSA-OAEP", hash: "SHA-256" },
    keyPair.privateKey,
            encryptedKeyBuffer
          );
      const aesKey = await window.crypto.subtle.importKey(
            "raw",
 aesKeyBuffer,
            { name: "AES-CBC" },
    false,
  ["decrypt"]
          );
      const ivBuffer = Uint8Array.from(atob(response.data.iv), c => c.charCodeAt(0));
      const ciphertextBuffer = Uint8Array.from(atob(response.data.ciphertext), c => c.charCodeAt(0));
     const decryptedBuffer = await window.crypto.subtle.decrypt(
        {
name: "AES-CBC",
   iv: ivBuffer,
},
    aesKey,
    ciphertextBuffer
          );
          const decryptedData = new TextDecoder().decode(decryptedBuffer);
          // console.log("Decrypted OIDC Data:", decryptedData);
          dynamicOidcSettings = JSON.parse(decryptedData);
     ssoUser = true;
        } else {
           // console.log("No OIDC settings returned. Using default config.");
    }
      } catch (error) {
     // console.error("Error during SSO check, using default config:", error);
      }
      
 setIsSSOUser(ssoUser);

      const msalConfig = {
        auth: {
  clientId: dynamicOidcSettings?.ClientId,
   authority: dynamicOidcSettings?.Authority.replace("/v2.0", ""),
          redirectUri: '/',
          postLogoutRedirectUri: '/',
          navigateToLoginRequestUrl: false,
        },
        cache: {
          cacheLocation: 'sessionStorage',
        storeAuthStateInCookie: false,
   },
      };

      const instance = new PublicClientApplication(msalConfig);

      if (!instance.getActiveAccount() && instance.getAllAccounts().length > 0) {
      instance.setActiveAccount(instance.getAllAccounts()[0]);
   }

      instance.addEventCallback((event) => {
        if (
       (event.eventType === EventType.LOGIN_SUCCESS ||
            event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS ||
   event.eventType === EventType.SSO_SILENT_SUCCESS) &&
          event.payload.account
     ) {
          // console.log("Dataaaaaaaaaaaaaaaaaaa:",JSON.stringify(event.payload),event.payload.idToken);
          sessionStorage.setItem("sso_token_type", event.payload.tokenType);
      sessionStorage.setItem("sso_access_token", event.payload.idToken);
  }
      });
      
      setMsalInstance(instance);
    };

    performSSOCheck();
  }, []);

  if (!msalInstance) {
 return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <img src={loadingGif} alt="Loading..." />
      </div>
    );
  }

  return (
    <MsalProvider instance={msalInstance}>
      <MainContent isSSOUser={isSSOUser}/>
    </MsalProvider>
  );
}

export default App;
